import { ArticleBatchDto } from "./article-batch.dto";
import { ArticleDto } from "./article.dto";
import { PackagingDto } from "./packaging.dto";
import { UserDto } from "./user.dto";

export class RawMaterialDto{
    id?: number;
    productionOrderProcessesId?: number;
    articleId?: number;
    articleBatchId?: number;
    articleBatch?: ArticleBatchDto;
    article?: ArticleDto;
    usedPackaging?: PackagingDto;
    usedPackagingId?: number;
    rawMaterialToUseId?: number;
    rawQuantity!: number;
    usedQuantity?: number;
    estimatedQuantity?: number;
    createdById?: number;
    createdBy?: UserDto;
    updatedById?: number;
    isLoadedOnMachine?: boolean;
}
